

const localIpAddressRegex = /^(localhost|127\.\d{1,3}\.\d{1,3}\.\d{1,3}|::1)$/;

export function isLocalhostOrIpAddress(url:string | URL): boolean {
    try {
        const urlObj = url instanceof URL ? url : new URL(url);
        const hostname = urlObj.hostname;
        // Check for localhost
        if (hostname === 'localhost' || hostname === '::1' || localIpAddressRegex.test(hostname)) {
            return true;
        }
        return false;
    }
    catch (e) {
        return false;
    }
}